<template>
  <div>
    <b-modal id="modal-edit" v-model="showModal" size="xl" title="Detail Penilaian Kinerja" hide-footer scrollable>
      <b-container>
        <b-card>
          <!-- Stepper Progress -->
          <b-progress :max="steps.length" height="20px" class="mb-3">
            <b-progress-bar :value="currentStep + 1" variant="info"> Step {{ currentStep + 1 }} / {{ steps.length }} </b-progress-bar>
          </b-progress>

          <!-- Step Title -->
          <h4 class="mb-4 text-center">{{ steps[currentStep].title }}</h4>

          <!-- Step 1: Identitas Penilai -->
          <div v-if="currentStep === 0">
            <b-form>
              <b-form-group label="Email" label-cols-md="4">
                <b-form-input v-model="data.email" disabled></b-form-input>
              </b-form-group>

              <b-form-group label="Nama Penilai" label-cols-md="4">
                <b-form-input v-model="data.namaPenilai" disabled></b-form-input>
              </b-form-group>

              <b-form-group label="Jabatan Penilai" label-cols-md="4">
                <b-form-input v-model="data.jabatanPenilai" disabled></b-form-input>
              </b-form-group>

              <b-form-group label="Tempat Tugas" label-cols-md="4">
                <b-form-input v-model="data.tempatTugas" disabled></b-form-input>
              </b-form-group>

              <b-form-group label="Tanggal Penilaian" label-cols-md="4">
                <b-form-input v-model="data.tanggalPenilaian" disabled></b-form-input>
              </b-form-group>

              <b-form-group label="Nama Karyawan" label-cols-md="4">
                <b-form-input v-model="data.namaKaryawan" disabled></b-form-input>
              </b-form-group>

              <b-form-group label="Tugas Kerja Karyawan" label-cols-md="4">
                <b-form-input v-model="data.namaPosisi" disabled></b-form-input>
              </b-form-group>
            </b-form>
          </div>

          <!-- Step 2: Aspek Kepribadian -->
          <div v-else-if="currentStep === 1">
            <b-card-body>
              <b-form-group v-for="i in [1, 2, 3, 4, 5]" :key="i" :label="$store.state.kpi['penilaian' + i]" label-cols-md="4">
                <b-form-radio-group v-model="data['penilaian' + i]" :options="getOptions(i)" stacked class="pl-2" disabled />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Step 3: Aspek Komunikasi -->
          <div v-else-if="currentStep === 2">
            <b-card-body>
              <b-form-group v-for="i in [6, 7, 8, 9, 10]" :key="i" :label="$store.state.kpi['penilaian' + i]" label-cols-md="4">
                <b-form-radio-group v-model="data['penilaian' + i]" :options="getOptions(i)" stacked class="pl-2" disabled />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Step 4: Teknis Pekerjaan -->
          <div v-else-if="currentStep === 3">
            <b-card-body>
              <b-form-group v-for="i in [11, 12, 13, 14, 15]" :key="i" :label="$store.state.kpi['penilaian' + i]" label-cols-md="4">
                <b-form-radio-group v-model="data['penilaian' + i]" :options="getOptions(i)" stacked class="pl-2" disabled />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Step 5: Produktivitas -->
          <div v-else-if="currentStep === 4">
            <b-card-body>
              <b-form-group v-for="i in [16, 17, 18, 19, 20]" :key="i" :label="$store.state.kpi['penilaian' + i]" label-cols-md="4">
                <b-form-radio-group v-model="data['penilaian' + i]" :options="getOptions(i)" stacked class="pl-2" disabled />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Step 6: Catatan -->
          <div v-else-if="currentStep === 5">
            <b-card-body>
              <b-form-group label="Catatan Khusus" label-cols-md="4">
                <b-form-input v-model="data.catatanKhusus" disabled />
              </b-form-group>

              <b-form-group label="Persetujuan Penandatanganan" label-cols-md="4">
                <b-form-radio-group v-model="data.persetujuanPenandatanganan" :options="optionsSetuju" stacked disabled />
              </b-form-group>

              <b-form-group label="Jangka Waktu Kerja" label-cols-md="4">
                <b-form-input v-model="data.jangkaWaktuKerja" type="number" disabled />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Step Navigation -->
          <b-row class="mt-4">
            <b-col cols="6">
              <b-button block variant="secondary" :disabled="currentStep === 0" @click="prevStep"> Back </b-button>
            </b-col>
            <b-col cols="6">
              <b-button block variant="primary" v-if="currentStep < steps.length - 1" @click="nextStep"> Next </b-button>
              <b-button block variant="success" v-else @click="closeModal"> Tutup </b-button>
            </b-col>
          </b-row>

          <!-- Generator (commented out for now) -->
          <!-- <generator :data="data" /> -->
        </b-card>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      showModal: false,
      currentStep: 0,
      steps: [{ title: "Identitas Penilai" }, { title: "Aspek Kepribadian" }, { title: "Aspek Komunikasi" }, { title: "Teknis Pekerjaan" }, { title: "Aspek Produktivitas" }, { title: "Catatan" }],
    };
  },
  computed: {
    optionsSetuju() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.optionsSetuju?.[0] || "Setuju", value: true },
        { text: s.optionsSetuju?.[1] || "Tidak Setuju", value: false },
      ];
    },
  },
  methods: {
    getOptions(i) {
      const s = this.$store.state.kpi || {};
      const arr = s["options" + i] || [];
      const values = [3, 2, 1];
      return arr.map((text, idx) => ({
        text,
        value: values[idx] ?? null,
      }));
    },
    nextStep() {
      if (this.currentStep < this.steps.length - 1) this.currentStep++;
    },
    prevStep() {
      if (this.currentStep > 0) this.currentStep--;
    },
    closeModal() {
      this.$bvModal.hide("modal-edit");
    },
  },
};
</script>

<style scoped>
.b-progress {
  border-radius: 20px;
  overflow: hidden;
}
</style>
